import { useState, useRef, FormEvent } from 'react';
import { getApiBaseUrl } from '../constants';

const API_BASE = getApiBaseUrl();

function PinLoginPage() {
  const [email, setEmail] = useState('');
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const pinRef = useRef<HTMLInputElement>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE}/tokens/pin`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pin }),
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || 'Invalid PIN');
      }

      const { token } = await res.json();
      // Store token in localStorage for Bearer auth (cross-domain safe)
      localStorage.setItem('hw_access_token', token);
      window.location.reload();
    } catch (err: any) {
      setError(err.message || 'Something went wrong');
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: '#0a0a0f',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    }}>
      <form onSubmit={handleSubmit} style={{
        background: '#12121a',
        border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: 16,
        padding: '2rem',
        width: '100%',
        maxWidth: 360,
        boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
      }}>
        <h1 style={{
          color: '#f0f0f5',
          fontSize: '1.4rem',
          fontWeight: 600,
          marginBottom: '0.25rem',
          textAlign: 'center',
        }}>
          Homework Tracker
        </h1>
        <p style={{
          color: '#8b8b9e',
          fontSize: '0.85rem',
          textAlign: 'center',
          marginBottom: '1.5rem',
        }}>
          Sign in with your PIN
        </p>

        <label style={{ color: '#8b8b9e', fontSize: '0.8rem', display: 'block', marginBottom: 4 }}>
          Email
        </label>
        <input
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder="your@email.com"
          required
          autoComplete="email"
          style={{
            width: '100%',
            padding: '10px 12px',
            background: 'rgba(255,255,255,0.07)',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: 8,
            color: '#f0f0f5',
            fontSize: '0.95rem',
            marginBottom: '1rem',
            outline: 'none',
            boxSizing: 'border-box',
            fontFamily: 'inherit',
          }}
          onFocus={e => e.target.style.borderColor = '#7c3aed'}
          onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.1)'}
          onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); pinRef.current?.focus(); } }}
        />

        <label style={{ color: '#8b8b9e', fontSize: '0.8rem', display: 'block', marginBottom: 4 }}>
          PIN
        </label>
        <input
          ref={pinRef}
          type="tel"
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={6}
          value={pin}
          onChange={e => setPin(e.target.value.replace(/\D/g, '').slice(0, 6))}
          placeholder="6-digit PIN"
          required
          autoComplete="one-time-code"
          style={{
            width: '100%',
            padding: '10px 12px',
            background: 'rgba(255,255,255,0.07)',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: 8,
            color: '#f0f0f5',
            fontSize: '1.2rem',
            letterSpacing: '0.3em',
            textAlign: 'center',
            marginBottom: '1.25rem',
            outline: 'none',
            boxSizing: 'border-box',
            fontFamily: 'inherit',
          }}
          onFocus={e => e.target.style.borderColor = '#7c3aed'}
          onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.1)'}
        />

        {error && (
          <p style={{
            color: '#fca5a5',
            fontSize: '0.85rem',
            textAlign: 'center',
            marginBottom: '1rem',
          }}>
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={loading || pin.length !== 6}
          style={{
            width: '100%',
            padding: '12px',
            background: loading || pin.length !== 6
              ? 'rgba(124,58,237,0.3)'
              : 'linear-gradient(135deg, #7c3aed 0%, #f59e0b 100%)',
            color: 'white',
            border: 'none',
            borderRadius: 8,
            fontSize: '1rem',
            fontWeight: 600,
            cursor: loading || pin.length !== 6 ? 'not-allowed' : 'pointer',
            fontFamily: 'inherit',
          }}
        >
          {loading ? 'Signing in...' : 'Sign In'}
        </button>
      </form>
    </div>
  );
}

export default PinLoginPage;
